import React, { useState, useEffect } from 'react';

// import { Link } from 'react-router-dom';

import MDParser from '../md-parser';

import './index.css';

const Component = () => {
    const mdURL = `${process.env.PUBLIC_URL}/_data/home/research-n-pub.md`;

    const [content, setContent] = useState('');

    useEffect(() => {
        // GET QuickLinks
        fetch(mdURL)
            .then((res) => res.text())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="ResearchAndPublications" className="research-and-publications">
            <h3>Research &amp; Publications</h3>
            <MDParser content={content} />
            {/* <p>
                <i className="fas fa-external-link-alt" />
                &nbsp;
                <Link to="publications">Full List of Publications</Link>
            </p> */}
        </div>
    );
};

export default Component;
